export enum NotificationChannel {
    MyRsu = 'MyRsu',
    RsuEmail = 'RsuEmail',
    Sms = 'Sms'
}

export const notificationChannels = Object.keys(NotificationChannel) as NotificationChannel[];

export enum NotificationChannelState {
    Unavailable = 0,
    Available = 1,
    Required = 2
}

export const channelStatePropertyMap = {
    [NotificationChannel.MyRsu]: 'MyRsuChannel',
    [NotificationChannel.RsuEmail]: 'RsuEmailChannel',
    [NotificationChannel.Sms]: 'SmsChannel'
};

export const userChannelPropertyMap = {
    [NotificationChannel.MyRsu]: 'IsMyRsyEnabled',
    [NotificationChannel.RsuEmail]: 'IsRsuEmailEnabled',
    [NotificationChannel.Sms]: 'IsSmsEnabled'
};

export enum NotificationSendingMethod {
    Auto = 'Auto',
    Manual = 'Manual'
}

export enum NotificationStatus {
    Draft = 'Draft',
    Pending = 'Pending',
    Finished = 'Finished'
}

export const notificationStatuses = Object.keys(NotificationStatus) as NotificationStatus[];

export enum NotificationLanguage {
    LV = 'LV',
    EN = 'EN'
}

export enum NotificationRequestStatus {
    Pending = 'Pending',
    Sent = 'Sent',
    Error = 'Error'
}

export const notificationRequestStatuses = Object.keys(NotificationRequestStatus) as NotificationRequestStatus[];

export interface INotificationListItem {
    Id: number;
    AuthorUpn: string;
    AuthorName: string;
    AuthorSurname: string;
    Status: string;
    Created: Date;
    Sent?: Date;
    Template: string;
    Type: string;
    Subject: string;
    Sender: string;
}

export interface INotificationInboxListItem {
    Id: number;
    Date: Date;
    Type: string;
    Subject: string;
    Message: string;
    ShortMessage: string;
}

export interface INotificationInboxStatus {
    Channel: NotificationChannel;
    Status: NotificationRequestStatus;
}

export interface INotification {
    Id: number;
    Type: string;
    TypeId: string;
    Template: string;
    TemplateId: string;
    Status: NotificationStatus;
    Sender: string;
    SubjectLV: string;
    SubjectEN: string;
    MessageLV: string;
    MessageEN: string;
    ShortMessageLV: string;
    ShortMessageEN: string
    MyRsuChannel: NotificationChannelState;
    RsuEmailChannel: NotificationChannelState;
    SmsChannel: NotificationChannelState;
    Recipients: INotificationRecipient[];
    Requests: INotificationRequest[];
}

export interface INotificationRecipient {
    Id: number;
    Upn: string;
    Name: string;
    Surname: string;
    Language: NotificationLanguage;
    Channels: NotificationChannel[];
}

export interface INotificationRequest {
    Id: number;
    RecipientId: number;
    Channel: NotificationChannel;
    Status: NotificationRequestStatus;
    Sent?: Date;
    Error?: string;
}

export interface INotificationEdit {
    Sender: string;
    SubjectLV: string;
    SubjectEN: string;
    MessageLV: string;
    MessageEN: string;
    ShortMessageLV: string;
    ShortMessageEN: string;
    MyRsuChannel: NotificationChannelState;
    RsuEmailChannel: NotificationChannelState;
    SmsChannel: NotificationChannelState;
}

export interface INotificationUserChannel {
    NotificationType: string;
    NotificationTypeId: string;
    IsMyRsuEnabled: boolean;
    IsRsuEmailEnabled: boolean;
    IsSmsEnabled: boolean;
}
